<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
會員中心              </p>
	</div>
   <div class="mem-full">

 <Center title='2' />

<div class="mem-con">


	<div class="login-r1">
	<div class="re-tit add-ship">
		<div class="coll-pik"></div><h4>我的收藏</h4>
		
		
	</div>

	   <div class="home-arr">
		   
	   
	   	   <div class="con">
	   		   <ul>
				 
	   				   <li v-for="it in news">
						     <router-link :to="'/product/details?id='+it.inventoryId">
						  
						     <div class="skr">
								 
								   <el-tooltip class="item" effect="dark" content="選擇選項" placement="left" popper-class="draw_share_atooltip">
								     <div> <img class="cart" @click.prevent="sandYart(it)" src="../../assets/cart.png" /></div>
								    </el-tooltip>
								 <el-tooltip class="item" effect="dark" content="快速查看" placement="left" popper-class="draw_share_atooltip">
								 <div> <img class="cart" @click.prevent="finding(it)" src="../../assets/find.png" /></div>
								  </el-tooltip>
								   <el-tooltip class="item" effect="dark" content="添加到心願單" placement="left" popper-class="draw_share_atooltip">
								 <div><img class="cart" v-if="it.if_shoucang==0" @click.prevent="collect(it)" src="../../assets/like.png" /><img class="cart" v-else @click.prevent="collect(it)" src="../../assets/likes.png" /></div>
								  </el-tooltip>
							 </div>
						
					
						   
						   <img class="fit" v-if="it.kucun==0" src="../../assets/sold_out.png" />
						   <div class="pic">
							   <img :src="it.img" />
						   </div>
						   <div class="txt">
							   <p>
{{it.title}}</p>
						   <p>
{{it.remark}} </p>
 <p class="time">
￥ {{it.price_sale}} </p>
 
						   </div>
	   					 </router-link>		  
	   				   </li>
				
																	
	   				 
	   			   </ul>
				 
	   	   </div>
	   </div>
	   
   <div class="page">
	     
	     <el-pagination
	       layout="prev, pager, next"
	       :total="total"
		   @current-change="pick">
	     </el-pagination>
	   </div>
	   <div v-if="cart">
	   		   <div class="brand" ></div>
	   <div class="carts">
	   		<div class="cart-tit">
	   			<h4>購物車</h4>
	   			<div class="cr" @click="cart=false">CLOSE<img src="../../assets/arr.png"  /></div>
	   			
	   					</div>
	   					<div class="cart-con">
	   						<ul>
	   							<li v-for="item in roll">
	   								<div class="lt">
	   								<div class="pic">
	   									<img :src="item.image" />
	   								</div>
	   								<div class="txt">
	   									<p><b>{{item.title}}</b></p><p>{{item.num}}× <b>CN ¥ {{item.price_sale}}</b></p>
	   								</div>
	   								</div>
	   								<div class="clo" @click="bit(item)">
	   									<img src="../../assets/arr.png" />
	   								</div>
	   							</li>
	   						
	   					</ul>
	   					</div>
	   					
	   					<div class="cart-bot">
	   						<div class="l1">
	   							<h4>小計:</h4>
	   							<h4>CN ¥{{price}}</h4>
	   						</div>
	   						<div class="l2">
	   							<router-link to="/product/cart"><div class="h-button cart-but">查看購物車</div></router-link>
	   							<router-link to="/product/order"><div class="h-button cart-but">結帳</div></router-link>
	   						</div>
	   					</div>
	   		   
	   </div></div>
	    <el-dialog
	   :visible.sync="dialogVisible"
	      width="1200px"
	     :before-close="handleClose"
	   >
	    <div class="product-st">
	    	 
	    			   <div class="pic">
	    				  <div class="l1">
	    					
	    					 <div class="block">
	    						<img :src="proImg" />
	    					   </div>
	    				  </div>
	    			
	    			   </div>
	    			    <div class="txt">
	    					<h2>{{pro.title}}</h2>
	    					<div class="l3" v-if="pro.kucun==0"><img src="../../assets/stock.png"></div>
	    					<div class="l4">
	    						￥ {{pro.price_sale}}
	    						<span></span>
	    					</div>
	    					<div class="l5">
	    						 <el-input-number size="mini"  v-model="num"  :min="1" :max="10" ></el-input-number>
	    						 <div class="cart-but" @click="sandYart(pro)">添加到購物車</div>
	    					</div>
	    					<div class="wishlist">
	    					
	    						<div class="co2">
	    							分享：
	    														<a href="https://www.facebook.com/sharer.php?u=http://cn.fmhd.209.qiyundongli.cn/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
	    															
	    														<a href="http://twitter.com/share?text=FuelMe&url=http://cn.fmhd.209.qiyundongli.cn/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
	    							<a href="http://service.weibo.com/share/share.php?url=http://cn.fmhd.209.qiyundongli.cn/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>
	    							
	    						</div>
	    					
	    					</div>
	    				</div>
	    </div>
	    </el-dialog>


	</div>

	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center
  },
 data() {
    return {
	
	
		num: 1,
		dialogVisible: false,
		info:'',
		news:[],
		notice:[],
		total:'',
		id:'',
		pro:'',
		proImg:'',
		page:1,
		channel_id:0,
		hans:'',
		cart:false,
		roll:'',
		channel:''
		
	
		
    
    };
  },  mounted() {
	  
 this.channel_id = this.$route.query.id;
		this.sandMate();
		this.sandHans();
		this.sandChan();
		this.sandCase();
		this.sandCart();
		
		},methods: {
			finding(it){
				
				this.proImg=it.img
				this.id=it.inventoryId
				this.dialogVisible=true
				this.sandCase()
			
			},
		
			
		sandCase(){
		
			this.$axios({
			  method: "post",
			  url: "service.php?action=product_detail",
			  data: {inventoryId:this.id},  
			}).then((res) => {
				let data=res.data;
			
				if(data.code==1){
					this.pro=data.data;
				}
			 
			});
		
		}, buff(item){
				this.channel_id=item
				this.sandMate()
			},handleClose(done) {
			this.num=1
			done();
       
      },sandYart(it){
		  this.id=it.inventoryId
				if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.id,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
					this.cart=true;
					this.sandCart()
					
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},sandCart(){
				this.price=0;
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_lists",
				  data: {},  
				}).then((res) => {
					let data=res.data;
					
					
					if(data.code==1){
						this.roll=data.data;
						
						this.roll.forEach((item, index) => {
						
						
							this.price =this.price+item.price_sale * item.num
							
						})
						this.price=this.price.toFixed(2)
					}
				 
				});
			},bit(item){
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_del",
				  data: {inventoryId:item.inventoryId},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
						
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},
			collect(it){
				this.id=it.inventoryId
							if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:1},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
								this.sandMate()
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},
						pick(item){
							this.page=item;
							this.sandMate()
						},
			sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_collectList",
				  data: {page:this.page},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.news=data.data.list;
						this.total=data.data.count
						
					}
				 
				});
			
			},sandHans(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_plist",
				  data: {is_index:1},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.hans=data.data;
						
						
					}
				 
				});
			
			},sandChan(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_channel",
				  data: {},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.channel=data.data;
						
						
					}
				 
				});
			
			}
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 185px;
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			color:#0A0A0A;
			font-size: 16px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{
	.re-tit{
		display: flex;
		font-size: 16px;
		font-family: Arial;
		font-weight: bold;
		color: #0A0A0A;
		.coll-pik{
			margin-right: 10px;
		}
	}
}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
	.page{
		text-align: center;
		margin:50px auto;
	}
.address{
	.re-con{
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		.re-tit{
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
}
.coll-pik{
	width: 5px;
	height: 18px;
	background: #0A0A0A;

}
.add-set{
	margin-left: 10px;
}

	.home-arr{
		.con{

			ul{
			
				li{
					margin-top: 0;
					margin-bottom: 30px;
				height: 410px;
					.pic{	height: 293px;
						img{
						
							height: 293px;
						
						}
					
					}
				
				}
			
			
			}
		}
	}
.carts{
	.cart-but{
		width: auto;
	}
}
</style>